module.exports = __webpack_public_path__ + "static/media/Assets-01-Vienna-Town-Hall-hero.eb3329a5.jpg";